import { BaseComment } from '../base/base-comment';

export class IpEmployerRecordComment extends BaseComment {
  public employerId!: string;
}
